import {FetchApi} from '../lib/anuket-http';
import {streamHook, eventBus} from './Streams';
import {configs} from '../configs';

const certificateUrlStreamId = 'finisherCertificateUrl';
const certificateAthlinksId = 'athlinks';
const certificateCtId = 'ctl';

const getCertPath = (bib, eventId, eventCourseId, entryId, ctLiveEntryId) => {
  if(!!bib) {
    return `?bib=${bib}&eventCourseId=${eventCourseId}&eventId=${eventId}`
  }
  return `?id=${ctLiveEntryId || entryId}&eventCourseId=${eventCourseId}&eventId=${eventId}`
}

export function fetchFinisherCertificateUrl(
    bib,
    eventId,
    eventCourseId,
    entryId,
    ctLiveEntryId,
    t
  ) {
  const certBaseUrl = configs.finisherCertificateUrl;
  // const certBaseUrl = 'http://localhost:3000/finisherCertificate/';
  const certPath = getCertPath(bib,eventId,eventCourseId,entryId, ctLiveEntryId);
  const url = `${certBaseUrl}${certPath}`;
  const streamId = getStreamId(entryId, ctLiveEntryId);

  FetchApi.memoizeRawFetch(10000)(
    url,
    {
      method: 'GET'
    },
    false
  ).subscribe((msg) => {
      const status = msg.meta.status;

      if(status === 200) {
        eventBus.publish(streamId, {url: msg.meta.url});
      }
      else if(status === 401) {
        eventBus.publish(streamId, {error: t('A finish time is required to generate an athlete\'s finisher certificate.')});
      }
      else {
        eventBus.publish(streamId, {error: t('Finisher certificate not currently available, please check back later.')});
      }
    },
    () => {
      eventBus.publish(streamId, {error: t('Finisher certificate not currently available, please check back later.')});
    }
  );
}

/**
 * stream to feed og-image values for results that have badges
 * @param entryId
 * @param ctLiveEntryId
 * @returns {*}
 */
export function getFinisherCertificateUrl(entryId, ctLiveEntryId) {
  const streamId = entryId ? `${certificateAthlinksId}-${entryId}` : `${certificateCtId}-${ctLiveEntryId}`;

  return streamHook(`${certificateUrlStreamId}-${streamId}`);
}

const getStreamId = (entryId, ctLiveEntryId) => {
  const streamId = entryId ? `${certificateAthlinksId}-${entryId}` : `${certificateCtId}-${ctLiveEntryId}`;

  return `${certificateUrlStreamId}-${streamId}`;
};
